<template>
    <v-container fluid fill-height px-0 class="main-container container-fixed d-block">
        <div class="content-block scenario-block">
            <v-flex class="d-flex justify-space-between align-center mx-6 mb-4">
                <div class="arrow-btn d-inline-flex" @click="back">
                    <div
                        v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')"
                        class="d-inline-flex size-28 rotate-90"
                    />
                </div>
                <div class="title-text d-inline-flex">
                    {{ dataScenario.uid ? "Редактирование" : "Добавление" }} сценария
                </div>
                <div class="d-inline-flex" style="width: 28px"></div>
            </v-flex>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                class="auth-form"
                @submit.prevent
            >
                <v-layout column ma-0 mb-2 w-100>
                    <v-flex class="container-form__row">
                        <div class="auth-form__input">
                            <label for="scenarioName" class="main-text"> Название </label>
                            <v-text-field
                                v-model="dataScenario.name"
                                placeholder="Название"
                                id="scenarioName"
                                class="dark-input input-form-grey error-field"
                                :rules="rules"
                                :error="error"
                                :error-messages="errorMessage"
                                @input="deleteError"
                            ></v-text-field>
                        </div>
                    </v-flex>
                    <v-flex class="d-inline-flex container-form__row">
                        <div class="auth-form__input">
                            <label for="scenarioController" class="main-text"> Контроллер </label>
                            <v-select
                                v-model="controller"
                                placeholder="Контроллер"
                                id="scenarioController"
                                class="dark-input input-form-grey error-field dark-input-select"
                                :items="controllers"
                                item-text="name"
                                item-value="uid"
                                :menu-props="{
                                    bottom: true,
                                    offsetY: true,
                                    closeOnContentClick: true,
                                }"
                                :rules="rules"
                                :error="error"
                                :error-messages="errorMessage"
                                @change="deleteError"
                            >
                                <template #item="{item}">
                                    <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                                </template>
                                <template #no-data>
                                    <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                </template>
                            </v-select>
                        </div>
                    </v-flex>
                    <v-flex class="d-inline-flex container-form__row">
                        <div class="auth-form__input">
                            <label for="scenarioType" class="main-text"> Тип сценария </label>
                            <v-select
                                v-model="dataScenario.scenario_type"
                                placeholder="Тип сценария"
                                id="scenarioType"
                                class="dark-input input-form-grey error-field scenario-type dark-input-select"
                                :items="scenarioTypes"
                                item-text="name"
                                :menu-props="{
                                    bottom: true,
                                    offsetY: true,
                                    closeOnContentClick: true,
                                }"
                                :rules="rules"
                                :error="error"
                                :error-messages="errorMessage"
                                @change="deleteError"
                            >
                                <template #item="{item}">
                                    <v-flex class="menu-item d-inline-flex align-center">
                                        <div
                                            v-html="require(`!html-loader!@/assets/scenario-form/${item.icon}_icon.svg`)"
                                            class="d-inline-flex size-20 mr-3"
                                        />
                                        {{item.name}}
                                    </v-flex>
                                </template>
                                <template #selection="{item}">
                                    <v-flex class="d-inline-flex align-center">
                                        <div
                                            v-html="require(`!html-loader!@/assets/scenario-form/${item.icon}_icon.svg`)"
                                            class="d-inline-flex size-20 mr-3"
                                        />
                                        {{item.name}}
                                    </v-flex>
                                </template>
                                <template #no-data>
                                    <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                </template>
                            </v-select>
                        </div>
                    </v-flex>
                    <v-flex class="d-inline-flex container-form__row">
                        <div class="auth-form__input">
                            <label for="scenarioLocation" class="main-text"> Расположение </label>
                            <v-combobox
                                v-model="dataScenario.location"
                                placeholder="Расположение"
                                id="scenarioLocation"
                                class="dark-input input-form-grey"
                                :items="locations"
                                :rules="rules"
                                hide-details
                                :menu-props="{
                                    bottom: true,
                                    offsetY: true,
                                    closeOnContentClick: true,
                                }"
                                @update:search-input="setLocation"
                            >
                                <template #item="{item}">
                                    <v-flex style="padding: 10px 22px">{{item}}</v-flex>
                                </template>
                            </v-combobox>
                        </div>
                    </v-flex>
                    <v-flex class="d-inline-flex container-form__row">
                        <div class="auth-form__input">
                            <label for="scenarioMode" class="main-text"> Выполнение сценария </label>
                            <v-select
                                v-model="dataScenario.mode_work_scenario"
                                placeholder="Выполнение сценария"
                                id="scenarioMode"
                                class="dark-input input-form-grey error-field scenario-mode dark-input-select"
                                :items="endScenarioMode"
                                item-text="name"
                                :menu-props="{
                                    bottom: true,
                                    offsetY: true,
                                    closeOnContentClick: true,
                                }"
                                :rules="rules"
                                :error="error"
                                :error-messages="errorMessage"
                                @change="deleteError"
                            >
                                <template #item="{item}">
                                    <v-flex column class="menu-item">
                                        <div class="d-inline-flex align-center">
                                            <div
                                                v-html="require(`!html-loader!@/assets/scenario-form/${item.icon}_icon.svg`)"
                                                class="d-inline-flex size-24"
                                            />
                                            <span class="main-text ml-3">{{item.name}}</span>
                                        </div>
                                        <div class="small-text grey-text flex-wrap" style="margin-left: 30px" v-html="item.text"></div>
                                    </v-flex>
                                </template>
                                <template #no-data>
                                    <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                </template>
                            </v-select>
                        </div>
                    </v-flex>
                    <div class="mb-4">
                        <div class="main-text mb-1">
                            Активировать по дням:
                        </div>
                        <v-flex class="d-inline-flex">
                            <v-layout row ma-0 class="devices-list__block__title">
                                <v-flex class="d-inline-flex">
                                    <div
                                        v-for="(day, index) in weekdays"
                                        :key="index"
                                        class="weekday"
                                        :class="{'weekday__active': scenarioDays.includes(index)}"
                                        @click="setDay(index)"
                                    >
                                        {{ day }}
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </div>
                    <div>
                        <v-flex class="container-form__row" v-if="dataScenario.scenario_type == 1">
                            <label for="scenarioType" class="main-text"> Выберете тип </label>
                            <v-select
                                v-model="activeType"
                                placeholder="Выберете тип"
                                id="scenarioType"
                                class="dark-input input-form-grey error-field scenario-mode dark-input-select"
                                :items="activeTypes"
                                item-text="name"
                                item-value="value"
                                :menu-props="{
                                    bottom: true,
                                    offsetY: true,
                                    closeOnContentClick: true,
                                }"
                            >
                                <template #item="{item}">
                                    <v-flex column class="menu-item">
                                        <div class="d-inline-flex align-center">
                                            <div
                                                v-html="require(`!html-loader!@/assets/scenario-form/${item.icon}_icon.svg`)"
                                                class="d-inline-flex size-20"
                                            />
                                            <span class="main-text ml-3">{{item.name}}</span>
                                        </div>
                                    </v-flex>
                                </template>
                                <template #selection="{item}">
                                    <v-flex class="d-inline-flex align-center">
                                        <div
                                            v-html="require(`!html-loader!@/assets/scenario-form/${item.icon}_icon.svg`)"
                                            class="d-inline-flex size-20 mr-3"
                                        />
                                        {{item.name}}
                                    </v-flex>
                                </template>
                                <template #no-data>
                                    <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex class="container-form__row" v-if="dataScenario.scenario_type == 1 && activeType == 'time'">
                            <time-field
                                v-model="timeActive"
                                title="Время активации сценария:"
                                placeholder="Время активации сценария"
                            />
                        </v-flex>
                        <v-flex class="container-form__row" v-if="dataScenario.scenario_type == 1 && activeType == 'day'">
                            <label for="scenarioDayType" class="main-text"> Выберете время суток </label>
                            <v-select
                                v-model="dayType"
                                placeholder="Выберете время суток"
                                id="scenarioDayType"
                                class="dark-input input-form-grey scenario-mode dark-input-select"
                                :items="dayTypes"
                                item-text="name"
                                item-value="value"
                                :menu-props="{
                                    bottom: true,
                                    offsetY: true,
                                    closeOnContentClick: true,
                                }"
                            >
                                <template #item="{item}">
                                    <v-flex column class="menu-item">
                                        <div class="d-inline-flex align-center">
                                            <div
                                                v-html="require(`!html-loader!@/assets/scenario-form/${item.icon}_icon.svg`)"
                                                class="d-inline-flex size-20"
                                            />
                                            <span class="main-text ml-3">{{item.name}}</span>
                                        </div>
                                    </v-flex>
                                </template>
                                <template #selection="{item}">
                                    <v-flex class="d-inline-flex align-center">
                                        <div
                                            v-html="require(`!html-loader!@/assets/scenario-form/${item.icon}_icon.svg`)"
                                            class="d-inline-flex size-20 mr-3"
                                        />
                                        {{item.name}}
                                    </v-flex>
                                </template>
                                <template #no-data>
                                    <v-flex class="main-text" style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex class="container-form__row" v-if="dataScenario.scenario_type == 4">
                            <time-field
                                v-model="launchPeriod"
                                title="Периодичность запуска:"
                                placeholder="Периодичность запуска"
                                max="12:00"
                            />
                        </v-flex>
                        <label  class="main-text"> Время начала и окончания работы сценария </label>
                        <v-layout row mx-0 mt-2 mb-4 align-center>
                            <v-flex xs6 class="d-flex align-center justify-center pr-2">
                                <v-flex class="modal-row d-flex">
                                    <v-text-field
                                        v-model="timeStart"
                                        type="time"
                                        class="input-picker-grey time-field"
                                        dense
                                        hide-details
                                    ></v-text-field>
                                </v-flex>
                            </v-flex>
                            <v-flex xs6 class="d-flex align-center justify-center pl-2">
                                <v-flex class="modal-row d-flex">
                                    <v-text-field
                                        v-model="timeEnd"
                                        type="time"
                                        class="input-picker-grey time-field"
                                        dense
                                        hide-details
                                    ></v-text-field>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                        <v-flex>
                            <v-flex xs12 class="bold-text mb-3">Действия</v-flex>
                            <ActionsForm
                                :actionsData.sync="actions"
                                :devices="roomDevices"
                                :scenarios="scenarios"
                                :groups="groups"
                                :available="availableActions"
                                :edit="actionsEdit"
                                ref="actionsForm"
                            ></ActionsForm>
                        </v-flex>
                        <v-flex>
                            <v-flex xs12 class="bold-text mb-3">Условия</v-flex>
                            <ConditionsForm
                                :conditionsData.sync="conditions"
                                :devices="roomDevices"
                                :scenarios="scenarios"
                                :available="availableConditions"
                                :edit="conditionsEdit"
                                ref="conditionsForm"
                            ></ConditionsForm>
                        </v-flex>
                        <v-flex class="container-form__row d-flex justify-start">
                            <div class="d-inline-flex btn-block" style="width: auto; max-width: 50%;">
                                <v-switch
                                    v-model="!dataScenario.hidden"
                                    inset
                                    dense
                                    hide-details
                                    class="pa-0 ma-0"
                                    color="#FF8484"
                                ></v-switch>
                                <div class="main-text ml-2">Сценарий доступен гостю</div>
                            </div>
                        </v-flex>
                        <v-flex class="container-form__row d-flex">
                            <v-flex xs6 class="d-inline-flex">
                                <v-btn class="btn-dark main-text mr-2" @click="back">
                                    Отмена
                                </v-btn>
                            </v-flex>
                            <v-flex xs6 class="d-inline-flex">
                                <v-btn
                                    :disabled="!valid"
                                    @click="validate"
                                    type="submit"
                                    class="yellow-btn main-text ml-2"
                                >
                                    Сохранить
                                </v-btn>
                            </v-flex>
                        </v-flex>
                    </div>
                </v-layout>
            </v-form>
            <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
        </div>
    </v-container>
</template>

<script>
import ActionsForm from "@/components/scenarios/form/ActionsForm";
import ConditionsForm from "@/components/scenarios/form/ConditionsForm";
import ModalWaiting from "@/components/modals/ModalWaiting";

export default {
    name: "AddScenarioPage",
    components: {
        ActionsForm,
        ConditionsForm,
        ModalWaiting,
    },
    data() {
        return {
            controllers: [],
            timeActive: "12:00",
            timeStart: "00:00",
            timeEnd: "23:59",
            launchPeriod: "00:01",
            weekdays: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"],
            scenarioDays: [0, 1, 2, 3, 4, 5, 6],
            controller: null,
            dataScenario: {},
            scenarioTypes: [
                {
                    name: "Запуск по таймеру",
                    value: 1,
                    icon: "clock",
                },
                {
                    name: "Запуск вручную",
                    value: 2,
                    icon: "pointer",
                },
                {
                    name: "Запуск по условию",
                    value: 3,
                    icon: "condition",
                },
                {
                    name: "Цикличный запуск",
                    value: 4,
                    icon: "cycle",
                },
            ],
            devices: [],
            roomDevices: [],
            conditions: [],
            actions: [],
            availableActions: {},
            availableConditions: {},
            scenarios: [],
            locations: [],
            groups: [],
            activeTypes: [
                {
                    name: "Время",
                    value: "time",
                    icon: "simple_clock",
                },
                {
                    name: "Время суток",
                    value: "day",
                    icon: "moon_sun",
                },
            ],
            activeType: null,
            dayTypes: [
                {
                    name: "Рассвет",
                    value: "dawn",
                    icon: "dawn",
                },
                {
                    name: "Восход",
                    value: "sunrise",
                    icon: "sunrise",
                },
                {
                    name: "Полдень",
                    value: "noon",
                    icon: "noon",
                },
                {
                    name: "Закат",
                    value: "sunset",
                    icon: "sunset",
                },
                {
                    name: "Сумерки",
                    value: "dusk",
                    icon: "dusk",
                },
            ],
            dayType: null,
            scenarioID: null,
            conditionsEdit: [],
            actionsEdit: [],
            save: false,
            rules: [value => !!value || 'Обязательное поле'],
            valid: true,
            error: null,
            errorMessage: null,
            errorModalMessage: null,
            endScenarioMode: [
                {
                    name: "Завершить в любом случае",
                    value: 1,
                    text: "Сценарий выполнится до конца, даже если<br>какие-то команды запустятся с ошибкой",
                    icon: "continue",
                },
                {
                    name: "Прервать в случае ошибки",
                    value: 2,
                    text: "Если на каком-то шаге появится ошибка,<br>последующие действия не выполнятся",
                    icon: "interrupt",
                },
            ],
            openModalWaiting: false,
            home: null,
        };
    },
    mounted() {
        this.home = this.$store.getters.home.uid || this.$store.getters.home;
    },
    watch: {
        controller(val) {
            if (val) {
                this.getDevices();
            } else {
                this.roomDevices = [];
                this.devices = [];
            }
        },
        home(val) {
            if (val) {
                this.getControllers();
                this.getScenarios();
            }
        }
    },
    methods: {
        getControllers() {
            this.openModalWaiting = true;
            this.$http.get('/controllers/home/management-controller/' + this.home + '/')
                .then((response) => {
                    this.controllers = response.data.results;
                    if (this.$route.query.scenario) {
                        this.scenarioID = this.$route.query.scenario;
                        this.getScenarioData();
                    } else {
                        this.openModalWaiting = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.openModalWaiting = false;
                });
        },
        getScenarios() {
            this.$http.get('/scenarios/home/scenarios-list/' + this.home + '/')
                .then((response) => {
                    this.scenarios = response.data.scenarios;
                    this.locations = response.data.locations;
                    this.groups = response.data.groups;
                    this.availableActions = response.data.available_conditions_and_actions.actions;
                    this.availableConditions = response.data.available_conditions_and_actions.conditions;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addScenario() {
            if (this.save) {
                return;
            }
            this.openModalWaiting = true;
            this.save = true;
            if (!this.dataScenario.hidden) {
                this.dataScenario.hidden = false;
            }
            this.dataScenario.controller = this.controller;
            if (this.dataScenario.scenario_type == 1) {
                if (this.timeActive && this.activeType == "time") {
                    this.dataScenario.time_start = this.timeActive;
                } else if (this.dayType && this.activeType == "day") {
                    this.dataScenario.time_start = this.dayType;
                }
            }
            this.dataScenario.weekdays = this.scenarioDays;
            this.dataScenario.time_interval_for_launching_start = this.timeStart;
            this.dataScenario.time_interval_for_launching_end = this.timeEnd;
            if (this.launchPeriod && this.dataScenario.scenario_type == 4) {
                let [hours, minutes] = this.launchPeriod.split(":");
                let period = (parseInt(hours) * 60 + parseInt(minutes)) * 60;
                this.dataScenario.launch_period = period;
            }

            this.$refs.conditionsForm.update();
            this.$refs.actionsForm.update();
            let conditionsArr = [];
            this.conditions.forEach((el, index) => {
                let element = {
                    index: index,
                    type: el.type == 5 ? 3 : el.type
                };
                if (el.device) {
                    element.trigger = el.trigger;
                    element.device = el.device.uid;
                }
                if (el.scenario) {
                    element.scenario = el.scenario.uid;
                }
                if (el.oper) {
                    element.operator = el.oper.value;
                }
                if (el.device || el.scenario || el.type == 4) {
                    let val = null;
                    if (el.variable.value_type == "int") {
                        val = parseInt(el.number);
                    }
                    if (el.variable.value_type == "time") {
                        val = el.time;
                    }
                    if (el.variable.value_type == "select") {
                        val = el.state ? el.state.value : el.state;
                    }
                    element.condition = {
                        field: el.variable.key,
                        value: val,
                        comparison_operator: el.comparison_operator,
                    };
                }
                conditionsArr.push(element);
            });
            let actionsArr = [];
            this.actions.forEach((el, index) => {
                let element = {
                    index: index,
                };
                if (el.device) {
                    element.device = el.device.uid;
                }
                if (el.scenario) {
                    element.scenario = el.scenario.uid;
                }
                if (el.group) {
                    element.scenario_group = el.group.uid;
                }
                if (el.sleep) {
                    element.sleep = el.sleep;
                }
                if (el.device || el.scenario || el.group) {
                    element.state = {};
                    if (el.variable.value_type == "int") {
                        element.state[el.variable.key] = parseInt(el.number);
                    } else {
                        element.state[el.variable.key] = _.isObject(el.state) ? el.state.value : el.state;
                    }
                }
                actionsArr.push(element);
            });
            this.dataScenario.conditions = conditionsArr;
            this.dataScenario.actions = actionsArr;

            let method = "post";
            let url = "/scenarios/home/scenarios/";
            if (this.scenarioID) {
                method = "put";
                url = "/scenarios/home/scenarios/" + this.scenarioID + "/";
            }
            this.$http[method](url, this.dataScenario)
                .then(() => {
                    this.openModalWaiting = false;
                    this.back();
                })
                .catch((error) => {
                    console.log(error);
                    this.errorModalMessage = error.response ? error.response.data[0].message : null;
                    this.openModalWaiting = false;
                    // this.$refs.modalError.open();
                })
                .finally(() => {
                    this.save = false;
                });
        },
        setDay(i) {
            let index = this.scenarioDays.indexOf(i);
            if (index != -1) {
                this.scenarioDays.splice(index, 1);
            } else {
                this.scenarioDays.push(i);
            }
        },
        getDevices() {
            this.$http.get('/devices/home/devices-list/' + this.home + '/?controller=' + this.controller)
                .then((response) => {
                    this.roomDevices = response.data.devices;
                    if (this.scenario) {
                        this.devices.forEach((el) => {
                            el.device = this.roomDevices.find((device) => {
                                return el.device == device.uid
                            });
                            if (typeof el.value != "boolean") {
                                el.temperature = el.value;
                                el.percent = el.value;
                                el.value = true;
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setLocation(val) {
            this.dataScenario.location = val;
        },
        getScenarioData() {
            this.dataScenario = {};
            this.$http.get('/scenarios/home/scenarios/' + this.scenarioID + '/')
                .then((response) => {
                    this.controller = response.data.controller;
                    this.dataScenario.name = response.data.name;
                    this.dataScenario.location = response.data.location;
                    this.dataScenario.scenario_type = response.data.scenario_type;
                    this.dataScenario.mode_work_scenario = response.data.mode_work_scenario;
                    if (response.data.weekdays) {
                        this.scenarioDays = response.data.weekdays;
                    }
                    if (this.dataScenario.scenario_type == 1) {
                        let day = this.dayTypes.find((el) => {
                            return el.value == response.data.time_start;
                        });
                        this.activeType = day ? "day" : "time";
                        if (day) {
                            this.dayType = response.data.time_start;
                        } else {
                            this.timeActive = response.data.time_start;
                        }
                    }
                    if (this.dataScenario.scenario_type == 4 && response.data.launch_period) {
                        let period = response.data.launch_period / 60;
                        let periodMinutes = period % 60;
                        let periodHours = parseInt(period / 60);
                        this.launchPeriod = `${String(periodHours).padStart(2, "0")}:${String(periodMinutes).padStart(2, "0")}`;
                    }
                    this.timeStart = response.data.time_interval_for_launching_start;
                    this.timeEnd = response.data.time_interval_for_launching_end;
                    this.dataScenario.hidden = !response.data.hidden;
                    this.actionsEdit = response.data.actions;
                    this.conditionsEdit = response.data.conditions;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        validate() {
            this.valid = this.$refs.form.validate();
            this.errorModalMessage = null;
            if (this.valid) {
                if (this.dataScenario.scenario_type == 3) {
                    if (this.conditions.length == 0) {
                        this.errorModalMessage = "Обязательно добавление условия";
                        // this.$refs.modalError.open();
                    }
                }
                if (this.actions.length == 0) {
                    this.errorModalMessage = "Обязательно добавление действия";
                    // this.$refs.modalError.open();
                }
                if (!this.errorModalMessage) {
                    this.addScenario();
                }
            } else {
                this.error = true;
                this.errorMessage = "Обязательное поле";
            }
        },
        deleteError() {
            this.errorMessage = null;
            this.error = false;
        },
        back() {
            this.$router.push({ name: "scenariospage" });
        },
    },
}
</script>

<style lang="scss" scoped>
.rotate-90.v-image {
    transform: rotate(90deg);
}

.scenario-block::v-deep .dark-input.v-input.v-text-field {
    &.error--text {
        .v-text-field__details {
            left: 0 !important;
            margin-top: 0;
        }
    }
}
.scenario-block .auth-form {
    width: 100%;
    padding: 0 24px 16px 24px;
    height: calc(100vh - 130px) !important;
    overflow-y: auto;
    position: relative;

    .container-form__row {
        max-height: 104px;
        min-height: 70px;
    }

    .dark-input.v-input.v-text-field.error--text {
        margin-bottom: 0;
    }

    .btn-dark,
    .yellow-btn {
        width: 100%;
    }
}
</style>